import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierLoadReadService,
  CarrierLoadBoardModel,
  LoadBoardRequest,
  AnyValueModelString,
  CarrierLoadModel,
  PageModelCarrierLoadListModel,
  CarrierLoadListRequest,
  CarrierLoadListModel
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierLoadReadApiService {
  constructor(private apiService: CarrierLoadReadService) {}

  public loadBoard(carrierId: string, body: LoadBoardRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadBoardModel[]> {
    return this.apiService.carrierLoadBoard(carrierId, body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public generateNumber(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelString> {
    return this.apiService.carrierLoadGenerateNumber(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getLoad(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listLoads(carrierId: string, body: CarrierLoadListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelCarrierLoadListModel> {
    return this.apiService.carrierLoadList(carrierId, body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getListModel(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadListModel> {
    return this.apiService.carrierLoadListModelGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
